import HubDashboardManagerNavItem from './HubDashboardManagerNavItem';

export default HubDashboardManagerNavItem;
